import * as yup from "yup";

const noConsecutiveSpaces = /^(?!.*\s{2,})(?!^\s)/;

export const deliveryFeeSchema = yup.object({
  id: yup.string().nullable(),
  country: yup
    .string()
    .required("Country is required field")
    .min(3, "The Country field should contain at least 3 letters.")
    .max(50, "The Country field should not exceed 50 characters.")
    .matches(
      noConsecutiveSpaces,
      "The Country field cannot contain consecutive spaces or start with a space."
    ),
  city: yup
    .string()
    .required("City is required field")
    .min(3, "The City field should contain at least 3 letters.")
    .max(50, "The City field should not exceed 50 characters.")
    .matches(
      noConsecutiveSpaces,
      "The City field cannot contain consecutive spaces or start with a space."
    ),
  neighborhood: yup
    .string()
    .required("Area is required field")
    .min(3, "The Area field should contain at least 3 letters.")
    .max(50, "The Area field should not exceed 50 characters.")
    .matches(
      noConsecutiveSpaces,
      "The Area field cannot contain consecutive spaces or start with a space."
    ),
  sizeSFee: yup
    .string()
    .required("All fees fields are required")
    .test(
      "is-positive-integer",
      "All fees must be a positive, integer number",
      (value) => /^\d+$/.test(value) && parseInt(value, 10) > 0
    ),
  sizeMFee: yup
    .string()
    .required("All fees fields are required")
    .test(
      "is-positive-integer",
      "All fees must be a positive, integer number",
      (value) => /^\d+$/.test(value) && parseInt(value, 10) > 0
    ),
  sizeLFee: yup
    .string()
    .required("All fees fields are required")
    .test(
      "is-positive-integer",
      "All fees must be a positive, integer number",
      (value) => /^\d+$/.test(value) && parseInt(value, 10) > 0
    ),
  allowCashOnDelivery: yup.boolean(),
  allowMobileMoney: yup.boolean()
});
